import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import PermissionMatrixCell from '../PermissionMatrixCell'
import { columnShape, rowShape } from '../../propTypes'
import useStyles from './styles'

const PermissionMatrixRow = ({ row, columns, disabledHint, onChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.row}>
      <Box className={classes.iconBox}>{row.icon}</Box>
      <Box className={classes.text}>
        <Typography className={classes.title}>{row.title}</Typography>
        {row.subtitle && (
          <Typography className={classes.subtitle}>{row.subtitle}</Typography>
        )}
      </Box>
      <Box className={classes.controls}>
        {columns.map((column) => {
          const cell = row.cells[column.id] || {}

          return (
            <PermissionMatrixCell
              key={column.id}
              color={column.color}
              width={column.width}
              checked={Boolean(cell.checked)}
              disabled={Boolean(cell.disabled)}
              disabledHint={disabledHint}
              onChange={(checked) =>
                onChange({ rowId: row.id, columnId: column.id, checked })
              }
            />
          )
        })}
      </Box>
      <Box className={classes.tail} />
    </Box>
  )
}

PermissionMatrixRow.propTypes = {
  row: rowShape.isRequired,
  columns: PropTypes.arrayOf(columnShape).isRequired,
  disabledHint: PropTypes.string,
  onChange: PropTypes.func,
}

export default PermissionMatrixRow
